import {rootContainer, TYPE} from "../services/container/root";
import AppcuesService, {IAppcuesIdentity} from "../services/appcues.service";
import {makeAutoObservable} from "mobx";
import PortalService from "../services/api/user-service";

class AppcuesStore {

    private _appcuesIdentity?: IAppcuesIdentity

    constructor() {
        makeAutoObservable(this, {}, {autoBind: true});
    }

    private get _appcuesService(): AppcuesService {
        return rootContainer.get<AppcuesService>(TYPE.AppcuesService);
    }

    private get _userService(): PortalService {
        return rootContainer.get<PortalService>(TYPE.UserService);
    }

    async load() {
        try {

            const userIdentity = await this._userService.getCurrentPortalIdentity();

            this._appcuesIdentity = {
                shop_id: userIdentity.portal_id,
                shop_name: userIdentity.portal_name,
                human_id: userIdentity.portal_id,
                human_email: userIdentity.logged_in_user_email
            }

            await this._appcuesService.setupAppcuesClient(this._appcuesIdentity);
        }
        catch (e) {
            console.error(e);
        }
    }

    public trackEvent(eventName: string, properties: Record<string, any>) {
        this._appcuesService.trackEvent(eventName, properties);
    }

}

export default new AppcuesStore();